import {
  shape,
  string,
  func
} from 'prop-types';

export default shape({
  begin: string.isRequired,
  changeBeginDate: func.isRequired,
  changeBeginDateTime: func.isRequired,
  end: string.isRequired,
  changeEndDate: func.isRequired,
  changeEndDateTime: func.isRequired
});



// WEBPACK FOOTER //
// ./src/utils/shapes/Period.js